import { trackNormalComponent } from '../../../util/trackComponent.js';
import './index.js';
import { IconV3 as IconV3Memoized } from './Icon.js';

var IconV3Tracking = trackNormalComponent(IconV3Memoized);

export { IconV3Tracking as IconV3 };
//# sourceMappingURL=external.js.map
